<template>
  <Layout>
    <template #content>
      <nuxt-child></nuxt-child>
    </template> 
  </Layout>
</template>
<script>
const Layout = require(`~/components/desktop/layouts/${process.env.DEF_webFrame}.vue`).default;
export default {
  components: {
    Layout,
  }
};
</script>
